import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

const Hero = () => {
  const { t, lang, setLang } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20earth%20from%20space%20showing%20continents%20and%20oceans%2C%20dramatic%20cinematic%20photography%2C%20deep%20navy%20and%20ivory%20tones%2C%20soft%20atmospheric%20glow%2C%20global%20perspective%2C%20breathtaking%20wide%20angle%20shot%2C%20deep%20space%20photography%2C%20ultra%20high%20resolution%2C%20artistic%20and%20cinematic%2C%20stars%20visible%20in%20background&width=1600&height=900&seq=hero1&orientation=landscape"
          alt="Global perspective"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/70 via-stone-900/50 to-stone-900/80" />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/30 via-transparent to-stone-900/30" />
      </div>

      <div
        className={`relative z-10 w-full text-center px-6 transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="h-px w-12 bg-white/30" />
          <span className="text-xs text-white/60 tracking-widest uppercase font-medium">
            {t('ONE PERSON · TWO LANGUAGES · ONE WORLD', '한 시선 · 두 언어 · 온 세계')}
          </span>
          <div className="h-px w-12 bg-white/30" />
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 tracking-tight">
          LUVing
        </h1>

        <p className="text-base md:text-xl text-white/70 mb-2 font-light tracking-wide">
          {t(
            'Global Affairs · International Order · Rights and Freedoms · Politics · Justice and Freedom · Law and Society',
            '국제 문제 · 국제 정세 · 국제 질서 · 인권·권리와 자유 · 정치 · 정의와 자유 · 법과 사회'
          )}
        </p>

        <div className="h-px w-24 bg-white/20 mx-auto my-6" />

        <p className="text-sm md:text-base text-white/60 max-w-xl mx-auto leading-relaxed mb-10 font-light">
          {t(
            'The world is complicated. Here\'s how I make sense of it. In two languages.',
            '복잡한 세상에서 따와 꽂은 갈피. 두 가지 언어로 큐레이팅된 시선'
          )}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/issues"
            className="px-7 py-3 bg-white text-stone-800 rounded-full text-sm font-semibold hover:bg-stone-100 cursor-pointer transition-all whitespace-nowrap"
          >
            {t('Explore Posts', '게시물 탐색')}
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 border border-white/30 text-white rounded-full text-sm font-medium hover:border-white/60 cursor-pointer transition-all whitespace-nowrap backdrop-blur-sm"
          >
            {t('About Me', '소개')}
          </Link>
        </div>

        <div className="flex items-center justify-center gap-1 mt-6">
          <button
            onClick={() => setLang('en')}
            className={`text-xs px-3 py-1 rounded-full cursor-pointer transition-all whitespace-nowrap ${lang === 'en' ? 'bg-white/20 text-white' : 'text-white/40 hover:text-white/70'}`}
          >
            English
          </button>
          <span className="text-white/20 text-xs">|</span>
          <button
            onClick={() => setLang('ko')}
            className={`text-xs px-3 py-1 rounded-full cursor-pointer transition-all whitespace-nowrap ${lang === 'ko' ? 'bg-white/20 text-white' : 'text-white/40 hover:text-white/70'}`}
          >
            한국어
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/40 animate-bounce">
        <span className="text-xs tracking-widest uppercase">{t('Scroll', '스크롤')}</span>
        <i className="ri-arrow-down-line text-sm" />
      </div>
    </section>
  );
};

export default Hero;
